import ErrorPage from "../ErrorPage/component";
import { validErrorCodeOr404 } from "../../constants/http";

const ErrorStatusPage = ({ match }) => {
    const statusNumber = Number(match.params.status);
    const statusCode = validErrorCodeOr404(statusNumber);

    return <ErrorPage statusCode={statusCode} />;
};

export default ErrorStatusPage;
